import { AppTrigger } from "./types";

export const initialAppTriggerState: AppTrigger = {
  param: {},
};
